(function () {
  "use strict";

  if (window.__diveInstantCartStateBlocksLoaded) return;
  window.__diveInstantCartStateBlocksLoaded = true;
  window.__diveInstantCartEnhancementsVersion = "2026-08-15.25";

  var DIVE_DREAMER_VARIANT_ID = 56617376874840;
  var DIVE_MIXER_VARIANT_ID = 56504302797144;
  var DIVE_DREAMER_MONTHLY_SELLING_PLAN_ID = 693084324184;
  var DIVE_DREAMER_ONE_TIME_PRICE = 4490;
  var DIVE_MIXER_ADDON_PRICE = 1200;

  var selectors = {
    cartRoot: "#ig9zaK5UfeCbkuA4k",
    filledState: ".icnPs6PbXDhfImG5R",
    emptyState: ".iolPVrhq04bzPIiZ4",
    cartCount: '[data-instant-dynamic-content-source="CART_COUNT"]',
    scrollBody: ".ibIL8zs2VWQcoBTTK",
    discountBannerText: ".iGlUt8RoD8uGS49FK",
    subscriptionUpsell: ".ivnTHl2uepWwMjDWL",
    mixerAddon: ".iKTN1abvp1QDDePeE",
    subscriptionActive: ".itiNDenVEEf8fUjQk",
    subscriptionUpgradeCta: ".iwtKapZEkPnRDFYM3",
    orderSummary: ".iVyFqRt3fQkrOv20X",
    mixerAddCta: ".iS7HpUQ2lt7CUmwNh",
    mixerComparePrice: ".iwDlEDXo9o86OvFjB",
    mixerPrice: ".iFmpMNSn7Z3JQYcCL",
    lineItem: "[data-instant-form-line-item-key]",
    quantityInput: 'input[name="quantity"]',
    quantityDecrement: '[data-instant-action-type="quantity-decrement"]',
    lineRemove: '[data-instant-action-type="adjust-line-item-quantity"]'
  };

  var timer = null;
  var cartRequest = null;
  var upgradeInFlight = false;
  var mixerAddInFlight = false;
  var subscriptionLineRemovalsInFlight = new Set();
  var subscriptionQuantityUpdatesInFlight = new Set();

  function getCart() {
    if (cartRequest) return cartRequest;

    cartRequest = fetch("/cart.js", {
      credentials: "same-origin",
      headers: { Accept: "application/json" }
    })
      .then(function (response) {
        return response.ok ? response.json() : null;
      })
      .catch(function () {
        return null;
      })
      .finally(function () {
        cartRequest = null;
      });

    return cartRequest;
  }

  function changeLine(key, quantity, sellingPlanId) {
    var payload = { id: key, quantity: quantity };

    if (sellingPlanId !== undefined) {
      payload.selling_plan = sellingPlanId;
    }

    return fetch("/cart/change.js", {
      method: "POST",
      credentials: "same-origin",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json"
      },
      body: JSON.stringify(payload)
    }).then(function (response) {
      if (!response.ok) throw new Error("Cart change failed");
      return response.json();
    });
  }

  function hasSellingPlan(item) {
    return Boolean(item && (item.selling_plan_allocation || item.selling_plan_name));
  }

  function isDiveDreamer(item) {
    return Number(item && item.variant_id) === DIVE_DREAMER_VARIANT_ID;
  }

  function isDiveMixer(item) {
    if (Number(item && item.variant_id) === DIVE_MIXER_VARIANT_ID) return true;

    var text = [
      item && item.product_title,
      item && item.title,
      item && item.handle,
      item && item.url
    ]
      .filter(Boolean)
      .join(" ");

    return /dive\s*mixer|espumador/i.test(text);
  }

  function isElementVisible(element) {
    if (!element || !element.getClientRects || !element.getClientRects().length) {
      return false;
    }

    while (element && element.nodeType === 1) {
      if (element.hidden) return false;

      var style = window.getComputedStyle(element);
      if (
        style.display === "none" ||
        style.visibility === "hidden" ||
        style.opacity === "0"
      ) {
        return false;
      }

      element = element.parentElement;
    }

    return true;
  }

  function setVisible(element, visible) {
    if (!element) return;

    var nextState = visible ? "visible" : "hidden";
    var currentStyle = window.getComputedStyle(element);
    var renderedStateMatches = visible
      ? !element.hidden &&
        currentStyle.display !== "none" &&
        currentStyle.visibility !== "hidden"
      : currentStyle.display === "none" ||
        currentStyle.visibility === "hidden";

    if (
      element.getAttribute("data-dive-visibility-state") === nextState &&
      renderedStateMatches
    ) {
      return;
    }

    element.setAttribute("data-dive-visibility-state", nextState);

    if (visible) {
      element.removeAttribute("hidden");
      element.style.setProperty("display", "flex", "important");
      element.style.setProperty("visibility", "visible", "important");
      element.style.removeProperty("height");
      element.style.removeProperty("width");
      element.style.removeProperty("opacity");
    } else {
      element.setAttribute("hidden", "hidden");
      element.style.setProperty("display", "none", "important");
      element.style.setProperty("visibility", "hidden", "important");
    }
  }

  function formatMoney(cents) {
    var value = (Number(cents) || 0) / 100;
    return "\u20ac" + value.toFixed(2).replace(".", ",");
  }

  function walkVisibleText(root, callback) {
    if (!root) return;

    var walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
    var node;

    while ((node = walker.nextNode())) {
      if (isElementVisible(node.parentElement)) callback(node);
    }
  }

  function replaceVisibleCartText(root, from, to) {
    if (!root || !from || !to || from === to) return;

    walkVisibleText(root, function (node) {
      if (node.nodeValue && node.nodeValue.indexOf(from) !== -1) {
        node.nodeValue = node.nodeValue.split(from).join(to);
      }
    });
  }

  function replaceExactVisibleCartText(root, from, to) {
    if (!root || !from || !to || from === to) return;

    walkVisibleText(root, function (node) {
      if ((node.nodeValue || "").trim() === from) {
        node.nodeValue = node.nodeValue.replace(from, to);
      }
    });
  }

  function findTightVisibleTextElement(root, exactText) {
    if (!root) return null;

    var best = null;

    Array.prototype.forEach.call(root.querySelectorAll("*"), function (element) {
      if (!isElementVisible(element)) return;

      var text = (element.textContent || "").trim();
      if (text === exactText && (!best || element.children.length < best.children.length)) {
        best = element;
      }
    });

    return best;
  }

  function clearSubscriptionNotes(root) {
    if (!root) return;

    root
      .querySelectorAll("[data-dive-cart-selling-plan-note]")
      .forEach(function (element) {
        element.remove();
      });
  }

  function ensureSubscriptionNote(root) {
    if (!root || root.querySelector("[data-dive-cart-selling-plan-note]")) return;
    if ((root.innerText || "").indexOf("Entrega cada mes") !== -1) return;

    var titleElement = findTightVisibleTextElement(root, "Dive Dreamer\u2122");
    if (!titleElement) return;

    var note = document.createElement("div");
    note.setAttribute("data-dive-cart-selling-plan-note", "true");
    note.textContent = "Entrega cada mes";
    note.style.color = "#166534";
    note.style.fontSize = "12px";
    note.style.fontWeight = "600";
    note.style.lineHeight = "1.25";
    note.style.marginTop = "2px";
    titleElement.insertAdjacentElement("afterend", note);
  }

  function hideStaleMixerLines(root) {
    if (!root) return;

    root
      .querySelectorAll(
        selectors.lineItem +
          '[data-instant-form-variant-id="' +
          DIVE_MIXER_VARIANT_ID +
          '"]'
      )
      .forEach(function (line) {
        line.setAttribute("data-dive-hidden-mixer-line", "true");
        line.style.setProperty("display", "none", "important");
        line.style.setProperty("visibility", "hidden", "important");
      });
  }

  function restoreMixerAddonCard(root) {
    if (!root) return;

    root.querySelectorAll(selectors.mixerAddon).forEach(function (wrapper) {
      wrapper
        .querySelectorAll(
          '[data-instant-form-variant-id="' +
            DIVE_MIXER_VARIANT_ID +
            '"]'
        )
        .forEach(function (card) {
          if (card.hasAttribute("data-instant-form-line-item-key")) return;

          var wasHiddenByDive = card.hasAttribute("data-dive-hidden-mixer-line");
          var inlineDisplay = card.style.getPropertyValue("display");
          var inlineVisibility = card.style.getPropertyValue("visibility");

          if (
            !wasHiddenByDive &&
            inlineDisplay !== "none" &&
            inlineVisibility !== "hidden"
          ) {
            return;
          }

          card.removeAttribute("data-dive-hidden-mixer-line");
          card.removeAttribute("hidden");
          card.style.removeProperty("display");
          card.style.removeProperty("visibility");
        });
    });
  }

  function normalizeVisibleQuantityInputs(root) {
    if (!root) return;

    root.querySelectorAll(selectors.quantityInput).forEach(function (input) {
      if (!isElementVisible(input)) return;

      input.setAttribute("min", "1");
      input.setAttribute("step", "1");
      input.setAttribute("inputmode", "numeric");

      var raw = String(input.value || "").trim();
      if (raw === "") return;

      var value = Number(raw);
      if (!Number.isFinite(value) || value < 1) {
        input.value = "1";
      } else if (value > 999) {
        input.value = "999";
      } else if (!Number.isInteger(value)) {
        input.value = String(Math.floor(value));
      }
    });
  }

  function syncCartShell(root, cart) {
    if (!root || !cart) return;

    var itemCount = Math.max(0, Number(cart.item_count) || 0);
    var hasItems = itemCount > 0;
    var filledState = root.querySelector(selectors.filledState);
    var emptyState = root.querySelector(selectors.emptyState);
    var countElement = root.querySelector(selectors.cartCount);

    setVisible(filledState, hasItems);
    setVisible(emptyState, !hasItems);

    if (countElement) {
      countElement.textContent = String(itemCount);
      setVisible(countElement.parentElement, hasItems);
    }
  }

  function findCartLineForItem(root, item) {
    if (!root || !item) return null;

    var exact = null;
    var fallback = null;

    root.querySelectorAll(selectors.lineItem).forEach(function (line) {
      if (
        !exact &&
        line.getAttribute("data-instant-form-line-item-key") === item.key
      ) {
        exact = line;
      }

      if (
        !fallback &&
        Number(line.getAttribute("data-instant-form-variant-id")) ===
          Number(item.variant_id)
      ) {
        fallback = line;
      }
    });

    return exact || fallback;
  }

  function setPriceReference(compareElement, referencePrice, linePrice) {
    if (!compareElement) return;

    var showReference =
      Number(referencePrice) > 0 && Number(referencePrice) > Number(linePrice);
    var nextState = showReference ? "visible" : "hidden";
    var formattedReference = showReference ? formatMoney(referencePrice) : "";

    if (compareElement.getAttribute("data-dive-reference-state") === nextState) {
      var renderedDisplay = window.getComputedStyle(compareElement).display;
      var renderedStateMatches =
        (showReference && renderedDisplay !== "none") ||
        (!showReference && renderedDisplay === "none");
      var renderedTextMatches =
        !showReference ||
        (compareElement.textContent || "").trim() === formattedReference;

      if (renderedStateMatches && renderedTextMatches) {
        return;
      }
    }

    compareElement.setAttribute("data-dive-reference-state", nextState);

    if (showReference) {
      if ((compareElement.textContent || "").trim() !== formattedReference) {
        compareElement.textContent = formattedReference;
      }

      compareElement.removeAttribute("hidden");
      compareElement.style.setProperty("display", "flex", "important");
      compareElement.style.setProperty("visibility", "visible", "important");
    } else {
      compareElement.style.setProperty("display", "none", "important");
      compareElement.style.removeProperty("visibility");
    }
  }

  function paintDiscountBanner(root, cart) {
    if (!root || !cart || !Array.isArray(cart.items)) return;

    var titles = [];

    (cart.cart_level_discount_applications || []).forEach(function (application) {
      if (application && application.title) titles.push(application.title);
    });

    cart.items.forEach(function (item) {
      (item.line_level_discount_allocations || []).forEach(function (allocation) {
        var application = allocation && allocation.discount_application;
        if (application && application.title) titles.push(application.title);
      });
    });

    titles = titles.filter(function (title, index, list) {
      return title && list.indexOf(title) === index;
    });

    var bannerText = root.querySelector(selectors.discountBannerText);
    if (!bannerText) return;

    var banner = bannerText.parentElement;
    if (banner) {
      banner.style.setProperty(
        "display",
        cart.items.length ? "flex" : "none",
        "important"
      );
      banner.style.setProperty("visibility", "visible", "important");

      var bannerIcon = banner.firstElementChild;
      if (bannerIcon && bannerIcon !== bannerText) {
        if (titles.length) {
          bannerIcon.style.removeProperty("display");
        } else {
          bannerIcon.style.setProperty("display", "none", "important");
        }
      }
    }

    bannerText.textContent = titles.length
      ? (titles.length > 1 ? "Descuentos aplicados: " : "Descuento aplicado: ") +
        titles.join(" · ")
      : "🚚 Envío gratis a Península";
  }

  function paintDreamerLinePrices(root, cart) {
    if (!root || !cart || !Array.isArray(cart.items)) return;

    cart.items.filter(isDiveDreamer).forEach(function (item) {
      var line = findCartLineForItem(root, item);
      if (!line) return;

      var quantity = Math.max(1, Number(item.quantity) || 1);
      var unitPrice = Number(item.final_price || item.price || 0);
      var linePrice = Number(item.final_line_price);

      if (!Number.isFinite(linePrice) || linePrice <= 0) {
        linePrice = unitPrice * quantity;
      }

      var referencePrice = Number(item.original_line_price);
      if (!Number.isFinite(referencePrice) || referencePrice <= 0) {
        referencePrice =
          Number(item.original_price || item.price || unitPrice) * quantity;
      }

      if (hasSellingPlan(item)) {
        referencePrice = DIVE_DREAMER_ONE_TIME_PRICE * quantity;
      }

      var priceElement = line.querySelector(
        '[data-instant-dynamic-content-source="PRICE"]'
      );
      var compareElement = line.querySelector(
        '[data-instant-dynamic-content-source="COMPARE_AT"]'
      );
      var formattedLinePrice = formatMoney(linePrice);

      if (
        priceElement &&
        (priceElement.textContent || "").trim() !== formattedLinePrice
      ) {
        priceElement.textContent = formattedLinePrice;
      }

      setPriceReference(compareElement, referencePrice, linePrice);
    });

    var formattedSubtotal = formatMoney(cart.items_subtotal_price);

    root
      .querySelectorAll(
        '[data-instant-dynamic-content-source="CART_SUBTOTAL_PRICE"]'
      )
      .forEach(function (subtotalElement) {
        if (
          (subtotalElement.textContent || "").trim() !== formattedSubtotal
        ) {
          subtotalElement.textContent = formattedSubtotal;
        }
      });

    var formattedTotal = formatMoney(cart.total_price);

    root
      .querySelectorAll(
        '[data-instant-dynamic-content-source="CART_TOTAL_PRICE"]'
      )
      .forEach(function (totalElement) {
        if ((totalElement.textContent || "").trim() !== formattedTotal) {
          totalElement.textContent = formattedTotal;
        }
      });

    var originalTotal = cart.items.reduce(function (sum, item) {
      var quantity = Math.max(1, Number(item.quantity) || 1);

      if (isDiveDreamer(item) && hasSellingPlan(item)) {
        return sum + DIVE_DREAMER_ONE_TIME_PRICE * quantity;
      }

      var referenceLinePrice = Number(item.original_line_price);
      if (!Number.isFinite(referenceLinePrice) || referenceLinePrice <= 0) {
        referenceLinePrice =
          (Number(item.original_price || item.price || item.final_price) || 0) *
          quantity;
      }

      return sum + referenceLinePrice;
    }, 0);

    root
      .querySelectorAll(
        '[data-instant-dynamic-content-source="CART_ORIGINAL_TOTAL_PRICE"]'
      )
      .forEach(function (originalTotalElement) {
        setPriceReference(
          originalTotalElement,
          originalTotal,
          cart.items_subtotal_price
        );
      });
  }

  function getReferenceCartTotal(cart) {
    if (!cart || !Array.isArray(cart.items)) return 0;

    return cart.items.reduce(function (sum, item) {
      var quantity = Math.max(1, Number(item.quantity) || 1);

      if (isDiveDreamer(item) && hasSellingPlan(item)) {
        return sum + DIVE_DREAMER_ONE_TIME_PRICE * quantity;
      }

      var referenceLinePrice = Number(item.original_line_price);
      if (!Number.isFinite(referenceLinePrice) || referenceLinePrice <= 0) {
        referenceLinePrice =
          (Number(item.original_price || item.price || item.final_price) || 0) *
          quantity;
      }

      return sum + referenceLinePrice;
    }, 0);
  }

  function getOrderDiscountRows(cart) {
    var amountsByTitle = Object.create(null);
    var order = [];

    function addDiscount(title, amount) {
      var normalizedTitle = String(title || "Descuento aplicado").trim();
      var normalizedAmount = Math.round(Number(amount) || 0);
      if (!normalizedTitle || normalizedAmount <= 0) return;

      if (!amountsByTitle[normalizedTitle]) {
        amountsByTitle[normalizedTitle] = 0;
        order.push(normalizedTitle);
      }

      amountsByTitle[normalizedTitle] += normalizedAmount;
    }

    cart.items.forEach(function (item) {
      if (!isDiveDreamer(item) || !hasSellingPlan(item)) return;

      var quantity = Math.max(1, Number(item.quantity) || 1);
      var allocation = item.selling_plan_allocation || {};
      var compareAtPrice =
        Number(allocation.compare_at_price) || DIVE_DREAMER_ONE_TIME_PRICE;
      var planPrice =
        Number(allocation.price) ||
        Number(item.original_price || item.price || item.final_price) ||
        0;
      var subscriptionSaving = Math.max(
        0,
        (compareAtPrice - planPrice) * quantity
      );

      addDiscount("Ahorro suscripción", subscriptionSaving);
    });

    var cartLevelTitles = Object.create(null);

    (cart.cart_level_discount_applications || []).forEach(function (application) {
      var normalizedApplication =
        (application && application.discount_application) || application || {};
      var title = String(normalizedApplication.title || "").trim();
      var amount =
        (application &&
          (application.total_allocated_amount || application.amount)) ||
        normalizedApplication.total_allocated_amount ||
        normalizedApplication.amount;

      if (title) cartLevelTitles[title] = true;
      addDiscount(title, amount);
    });

    cart.items.forEach(function (item) {
      var allocations = item.line_level_discount_allocations || [];

      allocations.forEach(function (allocation) {
        var application = allocation && allocation.discount_application;
        var title = String((application && application.title) || "").trim();
        if (title && cartLevelTitles[title]) return;

        addDiscount(title, allocation && allocation.amount);
      });

      if (!allocations.length) {
        (item.discounts || []).forEach(function (discount) {
          var title = String((discount && discount.title) || "").trim();
          if (title && cartLevelTitles[title]) return;

          addDiscount(title, discount && discount.amount);
        });
      }
    });

    var rows = order.map(function (title) {
      return { title: title, amount: amountsByTitle[title] };
    });
    var referenceTotal = getReferenceCartTotal(cart);
    var currentSubtotal = Number(cart.items_subtotal_price || cart.total_price) || 0;
    var expectedSaving = Math.max(0, referenceTotal - currentSubtotal);
    var accountedSaving = rows.reduce(function (sum, row) {
      return sum + row.amount;
    }, 0);
    var residualSaving = Math.max(0, expectedSaving - accountedSaving);

    if (residualSaving > 0) {
      addDiscount("Descuento aplicado", residualSaving);
      rows = order.map(function (title) {
        return { title: title, amount: amountsByTitle[title] };
      });
    }

    return rows.filter(function (row) {
      return row.amount > 0;
    });
  }

  function paintOrderSummaryDiscounts(root, cart) {
    if (!root || !cart) return;

    var summary = root.querySelector(selectors.orderSummary);
    if (!summary) return;

    summary.style.setProperty("margin-top", "auto", "important");

    var subtotalValue = summary.querySelector(
      '[data-instant-dynamic-content-source="CART_SUBTOTAL_PRICE"]'
    );
    var detail = subtotalValue && subtotalValue.parentElement
      ? subtotalValue.parentElement.parentElement
      : null;

    if (!detail) return;

    detail
      .querySelectorAll("[data-dive-discount-row]")
      .forEach(function (element) {
        element.remove();
      });

    var referenceTotal = getReferenceCartTotal(cart);
    var currentSubtotal = Number(cart.items_subtotal_price || cart.total_price) || 0;

    if (subtotalValue) {
      subtotalValue.textContent = formatMoney(referenceTotal || currentSubtotal);
    }

    var subtotalRow = subtotalValue && subtotalValue.parentElement;
    if (!subtotalRow) return;

    var anchor = subtotalRow;
    var nativeDiscountTitles = Object.create(null);

    detail
      .querySelectorAll(
        '[data-instant-repeater-type="CART_DISCOUNTS"] ' +
          '[data-instant-dynamic-content-source="DISCOUNT_NAME"]'
      )
      .forEach(function (element) {
        var title = String(element.textContent || "").trim();
        if (title) nativeDiscountTitles[title] = true;
      });

    getOrderDiscountRows(cart).forEach(function (discount) {
      if (nativeDiscountTitles[discount.title]) return;

      var row = document.createElement("div");
      var label = document.createElement("div");
      var amount = document.createElement("div");

      row.setAttribute("data-dive-discount-row", discount.title);
      row.style.setProperty("display", "flex");
      row.style.setProperty("align-items", "center");
      row.style.setProperty("justify-content", "space-between");
      row.style.setProperty("gap", "12px");
      row.style.setProperty("width", "100%");
      row.style.setProperty("padding", "5px 0");
      row.style.setProperty("border-bottom", "1px solid #F2F2F2");
      row.style.setProperty("font-size", "14px");
      row.style.setProperty("line-height", "1.35");

      label.textContent = discount.title;
      label.style.setProperty("color", "#147A4B");
      label.style.setProperty("font-weight", "500");

      amount.textContent = "-" + formatMoney(discount.amount);
      amount.style.setProperty("color", "#147A4B");
      amount.style.setProperty("font-weight", "600");
      amount.style.setProperty("white-space", "nowrap");

      row.appendChild(label);
      row.appendChild(amount);
      anchor.insertAdjacentElement("afterend", row);
      anchor = row;
    });
  }

  function paintSubscriptionPresentation(cart) {
    var root = document.querySelector(selectors.cartRoot);
    if (!root || !cart || !Array.isArray(cart.items)) return;

    var subscriptionDreamer = cart.items.find(function (item) {
      return isDiveDreamer(item) && hasSellingPlan(item);
    });

    if (!subscriptionDreamer) {
      clearSubscriptionNotes(root);
      return;
    }

    replaceVisibleCartText(
      root,
      "Suscripci\u00f3n selecionada",
      "Suscripci\u00f3n seleccionada"
    );

    var actualHasMixer = cart.items.some(isDiveMixer);

    if (!actualHasMixer) {
      hideStaleMixerLines(root);
    }

    ensureSubscriptionNote(root);
  }

  function syncMixerAddonPrice() {
    document.querySelectorAll(selectors.mixerAddon).forEach(function (element) {
      var compare = element.querySelector(selectors.mixerComparePrice);
      var price = element.querySelector(selectors.mixerPrice);

      if (compare) setVisible(compare, false);

      if (price) {
        var label =
          price.querySelector(".instant-rich-text") ||
          price.querySelector("p") ||
          price;

        if ((label.textContent || "").trim() !== "12,00 €") {
          label.textContent = "12,00 €";
        }
        price.setAttribute("aria-label", "Precio 12,00 €");
      }
    });
  }

  function paintMixerAddonState(hasMixer) {
    document.querySelectorAll(selectors.mixerAddon).forEach(function (element) {
      var cta = element.querySelector(selectors.mixerAddCta);
      if (!cta) return;

      var label =
        cta.querySelector(".instant-rich-text") ||
        cta.querySelector("p") ||
        cta.querySelector("span");

      if (label && (label.textContent || "").trim()) {
        var nextText = hasMixer ? "Añadido ✓" : "Añadir";
        if ((label.textContent || "").trim() !== nextText) {
          label.textContent = nextText;
        }
      }

      var knob = cta.firstElementChild;
      cta.setAttribute("role", "switch");
      cta.setAttribute("tabindex", hasMixer ? "-1" : "0");
      cta.setAttribute("aria-label", hasMixer ? "Dive Mixer añadido" : "Añadir Dive Mixer");
      cta.setAttribute("aria-checked", hasMixer ? "true" : "false");
      cta.setAttribute("data-dive-mixer-added", hasMixer ? "true" : "false");
      cta.style.setProperty("transition", "background-color 160ms ease");

      if (knob) {
        knob.style.setProperty("transition", "transform 160ms ease");
      }

      if (hasMixer) {
        cta.setAttribute("aria-disabled", "true");
        cta.style.setProperty("pointer-events", "none");
        cta.style.setProperty("background-color", "#43C98B");
        if (knob) knob.style.setProperty("transform", "translateX(14px)");
      } else {
        cta.removeAttribute("aria-disabled");
        cta.style.removeProperty("pointer-events");
        cta.style.removeProperty("background-color");
        if (knob) knob.style.removeProperty("transform");
      }
    });
  }

  function applyCartState(cart) {
    if (!cart || !Array.isArray(cart.items)) return;

    var root = document.querySelector(selectors.cartRoot);
    syncCartShell(root, cart);

    var hasSubscriptionDreamer = cart.items.some(function (item) {
      return isDiveDreamer(item) && hasSellingPlan(item);
    });
    var hasOneTimeDreamer = cart.items.some(function (item) {
      return isDiveDreamer(item) && !hasSellingPlan(item);
    });
    var hasMixer = cart.items.some(isDiveMixer);
    var showOneTimeOffers = hasOneTimeDreamer && !hasSubscriptionDreamer;

    document
      .querySelectorAll(selectors.subscriptionUpsell)
      .forEach(function (element) {
        setVisible(element, showOneTimeOffers);
      });

    document.querySelectorAll(selectors.mixerAddon).forEach(function (element) {
      setVisible(element, false);
    });

    document
      .querySelectorAll(selectors.subscriptionActive)
      .forEach(function (element) {
        setVisible(element, hasSubscriptionDreamer);
      });

    bindSubscriptionUpgradeCtas();
    restoreMixerAddonCard(root);
    syncMixerAddonPrice();
    paintMixerAddonState(hasMixer);
    paintDreamerLinePrices(root, cart);
    paintDiscountBanner(root, cart);
    paintOrderSummaryDiscounts(root, cart);

    if (hasSubscriptionDreamer) {
      paintSubscriptionPresentation(cart);
    } else {
      clearSubscriptionNotes(root);
    }

    normalizeVisibleQuantityInputs(root);
  }

  function resetCartScroll() {
    var root = document.querySelector(selectors.cartRoot);
    var scroller = root && root.querySelector(selectors.scrollBody);

    if (scroller) scroller.scrollTop = 0;
  }

  function notifyCartChanged(cart) {
    window.__diveInstantCartLastCart = cart;

    [
      "cart:change",
      "cart:changed",
      "cart:refresh",
      "cart:updated",
      "ajaxCart:updated",
      "theme:cart:change",
      "theme:cart:update",
      "instant:cart:refresh",
      "instant-cart:refresh"
    ].forEach(function (eventName) {
      [document, document.documentElement, window].forEach(function (target) {
        try {
          target.dispatchEvent(
            new CustomEvent(eventName, { detail: { cart: cart } })
          );
        } catch (error) {
          return;
        }
      });
    });

    if (window.Shopify && typeof window.Shopify.onCartUpdate === "function") {
      try {
        window.Shopify.onCartUpdate(cart);
      } catch (error) {
        return;
      }
    }
  }

  function armNativeLineRemoval(line, control) {
    if (!line || !control || line.hasAttribute("data-dive-removal-armed")) {
      return;
    }

    line.setAttribute("data-dive-removal-armed", "true");
    line.setAttribute("aria-busy", "true");
    line.style.setProperty("opacity", "0.55");
    control.setAttribute("aria-busy", "true");
    control.style.setProperty("pointer-events", "none");

    window.setTimeout(function () {
      if (!line.isConnected || !isElementVisible(line)) return;

      var input = line.querySelector(selectors.quantityInput);
      if (!input || Number(input.value) <= 0) return;

      line.removeAttribute("data-dive-removal-armed");
      line.removeAttribute("aria-busy");
      line.style.removeProperty("opacity");
      control.removeAttribute("aria-busy");
      control.style.removeProperty("pointer-events");
    }, 4000);
  }

  function isSubscriptionLine(line) {
    if (!line) return false;

    return Boolean(
      line.querySelector("[data-dive-cart-selling-plan-note]") ||
        (line.innerText || line.textContent || "").indexOf("Entrega cada mes") !== -1
    );
  }

  async function removeSubscriptionLine(line, control) {
    if (!line) return;

    var key = line.getAttribute("data-instant-form-line-item-key");
    if (!key || subscriptionLineRemovalsInFlight.has(key)) return;

    subscriptionLineRemovalsInFlight.add(key);
    armNativeLineRemoval(line, control);

    try {
      var nextCart = await changeLine(key, 0);
      applyCartState(nextCart);
      notifyCartChanged(nextCart);
      schedule(80);
    } catch (error) {
      console.warn("[Dive] subscription line removal failed", error);
      schedule(120);
    } finally {
      subscriptionLineRemovalsInFlight.delete(key);
    }
  }

  async function updateSubscriptionLineQuantity(
    line,
    control,
    resolveNextQuantity
  ) {
    if (!line) return;

    var domKey = line.getAttribute("data-instant-form-line-item-key");
    var trackingKey = domKey || String(DIVE_DREAMER_VARIANT_ID);
    if (subscriptionQuantityUpdatesInFlight.has(trackingKey)) return;

    subscriptionQuantityUpdatesInFlight.add(trackingKey);

    var input = line.querySelector(selectors.quantityInput);
    var currentQuantity = input ? Number(input.value) : null;

    if (control) {
      control.setAttribute("aria-busy", "true");
      control.style.setProperty("pointer-events", "none");
      control.style.setProperty("opacity", "0.55");
    }

    try {
      var cart = await getCart();
      if (!cart || !Array.isArray(cart.items)) return;

      var item = cart.items.find(function (cartItem) {
        return cartItem.key === domKey;
      });

      if (!item) {
        item = cart.items.find(function (cartItem) {
          return isDiveDreamer(cartItem) && hasSellingPlan(cartItem);
        });
      }

      if (!item) return;

      currentQuantity = Math.max(1, Number(item.quantity) || 1);

      var requestedQuantity =
        typeof resolveNextQuantity === "function"
          ? resolveNextQuantity(currentQuantity)
          : resolveNextQuantity;
      var nextQuantity = Number(requestedQuantity);

      if (!Number.isFinite(nextQuantity)) nextQuantity = currentQuantity;
      nextQuantity = Math.min(999, Math.max(0, Math.floor(nextQuantity)));

      if (input && nextQuantity > 0) {
        input.value = String(nextQuantity);
      }

      var nextCart =
        nextQuantity === currentQuantity
          ? cart
          : await changeLine(item.key, nextQuantity);

      applyCartState(nextCart);
      notifyCartChanged(nextCart);
      schedule(80);
    } catch (error) {
      if (input && Number.isFinite(currentQuantity) && currentQuantity > 0) {
        input.value = String(currentQuantity);
      }

      console.warn("[Dive] subscription quantity update failed", error);
      schedule(120);
    } finally {
      subscriptionQuantityUpdatesInFlight.delete(trackingKey);

      if (control && control.isConnected) {
        control.removeAttribute("aria-busy");
        control.style.removeProperty("pointer-events");
        control.style.removeProperty("opacity");
      }
    }
  }

  async function upgradeDreamerToSubscription(cta) {
    if (upgradeInFlight) return;

    upgradeInFlight = true;
    if (cta) {
      cta.setAttribute("aria-busy", "true");
      cta.style.setProperty("pointer-events", "none");
      cta.style.setProperty("opacity", "0.72");
    }

    try {
      var cart = await getCart();
      if (!cart || !Array.isArray(cart.items)) return;

      var oneTimeDreamerLines = cart.items.filter(function (item) {
        return isDiveDreamer(item) && !hasSellingPlan(item);
      });

      if (!oneTimeDreamerLines.length) {
        applyCartState(cart);
        return;
      }

      var dreamerQuantity = oneTimeDreamerLines.reduce(function (total, item) {
        return total + (Number(item.quantity) || 1);
      }, 0);

      var addResponse = await fetch("/cart/add.js", {
        method: "POST",
        credentials: "same-origin",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json"
        },
        body: JSON.stringify({
          items: [
            {
              id: DIVE_DREAMER_VARIANT_ID,
              quantity: dreamerQuantity || 1,
              selling_plan: DIVE_DREAMER_MONTHLY_SELLING_PLAN_ID
            }
          ]
        })
      });

      if (!addResponse.ok) throw new Error("Subscription add failed");

      var cartResponse = await fetch("/cart.js", {
        credentials: "same-origin",
        headers: { Accept: "application/json" }
      });
      var nextCart = cartResponse.ok ? await cartResponse.json() : null;
      if (!nextCart || !Array.isArray(nextCart.items)) {
        throw new Error("Subscription cart refresh failed");
      }

      var staleOneTimeLines = nextCart.items.filter(function (item) {
        return isDiveDreamer(item) && !hasSellingPlan(item);
      });

      for (var i = 0; i < staleOneTimeLines.length; i += 1) {
        nextCart = await changeLine(staleOneTimeLines[i].key, 0);
      }

      var mixerLines = (nextCart && nextCart.items ? nextCart.items : []).filter(
        isDiveMixer
      );

      for (var j = 0; j < mixerLines.length; j += 1) {
        nextCart = await changeLine(mixerLines[j].key, 0);
      }

      applyCartState(nextCart);
      notifyCartChanged(nextCart);
      schedule(120);
    } catch (error) {
      console.warn("[Dive] cart subscription upgrade failed", error);
      schedule(120);
    } finally {
      upgradeInFlight = false;

      if (cta && cta.isConnected) {
        cta.removeAttribute("aria-busy");
        cta.style.removeProperty("pointer-events");
        cta.style.removeProperty("opacity");
      }
    }
  }


  async function addMixerAddon(cta) {
    if (mixerAddInFlight) return;

    mixerAddInFlight = true;
    if (cta) {
      cta.setAttribute("aria-busy", "true");
      cta.style.setProperty("pointer-events", "none");
      cta.style.setProperty("opacity", "0.72");
    }

    try {
      var cart = await getCart();
      if (!cart || !Array.isArray(cart.items)) return;

      if (cart.items.some(isDiveMixer)) {
        applyCartState(cart);
        return;
      }

      var response = await fetch("/cart/add.js", {
        method: "POST",
        credentials: "same-origin",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json"
        },
        body: JSON.stringify({
          items: [{ id: DIVE_MIXER_VARIANT_ID, quantity: 1 }]
        })
      });

      if (!response.ok) throw new Error("Mixer add failed");

      var cartResponse = await fetch("/cart.js", {
        credentials: "same-origin",
        headers: { Accept: "application/json" }
      });
      var nextCart = cartResponse.ok ? await cartResponse.json() : null;

      applyCartState(nextCart);
      notifyCartChanged(nextCart);
      schedule(120);
    } catch (error) {
      console.warn("[Dive] mixer add failed", error);
      schedule(120);
    } finally {
      mixerAddInFlight = false;

      if (cta && cta.isConnected) {
        cta.removeAttribute("aria-busy");

        if (cta.getAttribute("data-dive-mixer-added") === "true") {
          cta.setAttribute("aria-disabled", "true");
          cta.style.setProperty("pointer-events", "none");
        } else {
          cta.removeAttribute("aria-disabled");
          cta.style.removeProperty("pointer-events");
        }
        cta.style.removeProperty("opacity");
      }
    }
  }

  function handleMixerAddClick(event) {
    var target = event.target;
    var cta =
      target && target.closest ? target.closest(selectors.mixerAddCta) : null;

    if (!cta || !isElementVisible(cta)) return false;

    event.preventDefault();
    event.stopPropagation();
    if (event.stopImmediatePropagation) event.stopImmediatePropagation();

    addMixerAddon(cta);
    return true;
  }

  function handleSubscriptionUpgradeClick(event) {
    var target = event.target;
    var cta =
      target && target.closest
        ? target.closest(selectors.subscriptionUpgradeCta)
        : null;

    if (!cta) return false;

    event.preventDefault();
    event.stopPropagation();
    if (event.stopImmediatePropagation) event.stopImmediatePropagation();

    upgradeDreamerToSubscription(cta);
    return true;
  }

  function bindSubscriptionUpgradeCtas() {
    document
      .querySelectorAll(selectors.subscriptionUpgradeCta)
      .forEach(function (cta) {
        cta.setAttribute("role", "button");
        cta.setAttribute("tabindex", "0");
        cta.setAttribute("aria-label", "Suscribirme y ahorrar");

        if (cta.getAttribute("data-dive-upgrade-bound") === "true") return;
        cta.setAttribute("data-dive-upgrade-bound", "true");

        var activate = function (event) {
          event.preventDefault();
          event.stopPropagation();
          if (event.stopImmediatePropagation) event.stopImmediatePropagation();
          upgradeDreamerToSubscription(cta);
        };

        cta.addEventListener("pointerup", activate, true);
        cta.addEventListener("click", activate, true);
        cta.addEventListener(
          "keydown",
          function (event) {
            if (event.key === "Enter" || event.key === " ") activate(event);
          },
          true
        );
      });
  }

  function handleSubscriptionRemoveClick(event) {
    var target = event.target;
    var control =
      target && target.closest ? target.closest(selectors.lineRemove) : null;

    if (!control || !isElementVisible(control)) return false;

    var line = control.closest(selectors.lineItem);
    if (!line || !isSubscriptionLine(line)) return false;

    event.preventDefault();
    event.stopPropagation();
    if (event.stopImmediatePropagation) event.stopImmediatePropagation();

    removeSubscriptionLine(line, control);
    return true;
  }

  function handleQuantityIncrementClick(event) {
    var target = event.target;
    var control =
      target && target.closest
        ? target.closest('[data-instant-action-type="quantity-increment"]')
        : null;

    if (!control || !isElementVisible(control)) return false;

    var line = control.closest(selectors.lineItem);
    if (!line || !isSubscriptionLine(line)) return false;

    event.preventDefault();
    event.stopPropagation();
    if (event.stopImmediatePropagation) event.stopImmediatePropagation();

    updateSubscriptionLineQuantity(line, control, function (quantity) {
      return quantity + 1;
    });
    return true;
  }

  function handleQuantityDecrementClick(event) {
    var target = event.target;
    var control =
      target && target.closest
        ? target.closest(selectors.quantityDecrement)
        : null;

    if (!control || !isElementVisible(control)) return false;

    var line = control.closest(selectors.lineItem);
    if (!line) return false;

    if (isSubscriptionLine(line)) {
      event.preventDefault();
      event.stopPropagation();
      if (event.stopImmediatePropagation) event.stopImmediatePropagation();

      updateSubscriptionLineQuantity(line, control, function (quantity) {
        return quantity - 1;
      });
      return true;
    }

    var input = line.querySelector(selectors.quantityInput);
    var quantity = input ? Number(input.value) : 1;

    if (Number.isFinite(quantity) && quantity > 1) return false;

    var removeControl = line.querySelector(selectors.lineRemove);
    if (!removeControl) return false;

    event.preventDefault();
    event.stopPropagation();
    if (event.stopImmediatePropagation) event.stopImmediatePropagation();

    // Reuse Instant's own remove action so line items, totals and empty state
    // update through the same internal path as the visible remove button.
    armNativeLineRemoval(line, control);

    window.setTimeout(function () {
      if (removeControl.isConnected) removeControl.click();
    }, 0);

    return true;
  }

  function handleSubscriptionQuantityChange(event) {
    var target = event.target;

    if (
      !target ||
      !target.matches ||
      !target.matches(selectors.quantityInput) ||
      !target.closest(selectors.cartRoot) ||
      !isElementVisible(target)
    ) {
      return false;
    }

    var line = target.closest(selectors.lineItem);
    if (!line) return false;

    var desiredQuantity = Number(target.value);
    if (!Number.isFinite(desiredQuantity) || desiredQuantity < 1) {
      desiredQuantity = 1;
    }

    desiredQuantity = Math.min(999, Math.floor(desiredQuantity));
    target.value = String(desiredQuantity);

    event.preventDefault();
    event.stopPropagation();
    if (event.stopImmediatePropagation) event.stopImmediatePropagation();

    updateSubscriptionLineQuantity(line, target, desiredQuantity);
    return true;
  }

  function handleQuantityKeydown(event) {
    var target = event.target;
    if (
      !target ||
      !target.matches ||
      !target.matches(selectors.quantityInput) ||
      !target.closest(selectors.cartRoot) ||
      !isElementVisible(target)
    ) {
      return;
    }

    if (
      event.key === "-" ||
      event.key === "+" ||
      event.key === "e" ||
      event.key === "E" ||
      event.key === "." ||
      event.key === ","
    ) {
      event.preventDefault();
    }
  }

  function handleQuantityInput(event) {
    var target = event.target;
    if (
      !target ||
      !target.matches ||
      !target.matches(selectors.quantityInput) ||
      !target.closest(selectors.cartRoot) ||
      !isElementVisible(target)
    ) {
      return;
    }

    var raw = String(target.value || "").trim();
    if (raw === "") return;

    var value = Number(raw);

    if (!Number.isFinite(value) || value < 1) {
      var shouldSyncMinimum = raw.indexOf("-") !== -1 || !Number.isFinite(value);
      target.value = "1";

      if (shouldSyncMinimum) {
        var line = target.closest(selectors.lineItem);
        if (line) updateSubscriptionLineQuantity(line, target, 1);
      }
    } else if (value > 999) {
      target.value = "999";
    } else if (!Number.isInteger(value)) {
      target.value = String(Math.floor(value));
    }
  }

  async function apply() {
    var cart = await getCart();
    applyCartState(cart);
  }

  function schedule(delay) {
    window.clearTimeout(timer);
    timer = window.setTimeout(apply, delay === undefined ? 120 : delay);
  }

  function isCartMutationNode(node) {
    if (!node || node.nodeType !== 1) return false;

    return Boolean(
      node.matches(selectors.cartRoot) ||
        node.closest(selectors.cartRoot) ||
        node.querySelector(selectors.cartRoot)
    );
  }

  function startObserver() {
    if (!document.body || !window.MutationObserver) return;

    new MutationObserver(function (mutations) {
      var shouldReconcile = mutations.some(function (mutation) {
        if (mutation.type === "attributes") {
          return isCartMutationNode(mutation.target);
        }

        if (isCartMutationNode(mutation.target)) return true;

        return (
          Array.prototype.some.call(
            mutation.addedNodes || [],
            isCartMutationNode
          ) ||
          Array.prototype.some.call(
            mutation.removedNodes || [],
            isCartMutationNode
          )
        );
      });

      if (shouldReconcile) schedule(100);
    }).observe(document.body, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ["class", "style", "hidden", "data-instant-state"]
    });
  }

  document.addEventListener(
    "click",
    function (event) {
      if (handleMixerAddClick(event)) return;
      if (handleSubscriptionRemoveClick(event)) return;
      if (handleQuantityIncrementClick(event)) return;
      handleQuantityDecrementClick(event);
    },
    true
  );

  document.addEventListener("keydown", handleQuantityKeydown, true);
  document.addEventListener("input", handleQuantityInput, true);

  document.addEventListener(
    "click",
    function (event) {
      var target = event.target;
      if (!target || !target.closest) return;

      var isCartRelevant =
        Boolean(target.closest(selectors.cartRoot)) ||
        Boolean(target.closest('a[href*="/cart/"]')) ||
        Boolean(
          target.closest(
            '[data-instant-action-type="open-overlay"], [data-instant-action-type="add-to-cart"]'
          )
        );

      if (!isCartRelevant) return;

      window.setTimeout(resetCartScroll, 180);
      schedule(650);
      window.setTimeout(function () {
        resetCartScroll();
        schedule(0);
      }, 2200);
    },
    false
  );

  document.addEventListener(
    "change",
    function (event) {
      handleQuantityInput(event);
      if (handleSubscriptionQuantityChange(event)) return;
      schedule(350);
    },
    true
  );

  window.addEventListener("pageshow", function () {
    schedule(80);
  });

  document.addEventListener("visibilitychange", function () {
    if (document.visibilityState === "visible") schedule(80);
  });

  function start() {
    startObserver();
    schedule(0);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", start, { once: true });
  } else {
    start();
  }
})();